export const bestMatchSort = 'Match+Score';
export const highestPriceSort = 'Retail+Price%7Cdesc';
export const lowestPriceSort = 'Retail+Price';
export const commissionSort = 'Commission%7Cdesc';
export const lowestCommissionSort = 'Commission';
export const discountSort = 'Price+Discount+Percent%7Cdesc';
